import { Button } from '@mui/material';
import { Row, Spacer } from '../../../components';
import React from 'react';
import { t } from 'i18next';

interface CloseButtonProps {
  setDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const CloseButton: React.FC<CloseButtonProps> = ({ setDrawerOpen }) => {
  return (
    <>
      <Spacer height='md' />
      <Row style={{ justifyContent: 'space-between' }}>
        <Button
          onClick={() => setDrawerOpen(false)}
          className='xs'
          variant='outlined'
          color='primary'>
          {t('Close')}
        </Button>
      </Row>
    </>
  );
};

export default CloseButton;
